import {
  airDisruptionApi,
  type CipherText,
  type DisruptionFailure,
  DisruptionRebookPollPQResponseEnum,
  DisruptionRebookPQResponseEnum,
  type RebookPollPQSuccess,
} from "@b2bportal/air-disruption-api";
import type { FlightsRebookState } from "@b2bportal/core-flights-rebook";
import {
  makeAxiosRequest,
  polling,
  type RichError,
} from "@b2bportal/core-utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api = airDisruptionApi(axios);

export const performPriceQuote = createAsyncThunk<
  { response: RebookPollPQSuccess; contractId: string; token: CipherText },
  { contractId: string; fareId: string; tripId: string },
  { state: FlightsRebookState; rejectValue: RichError<DisruptionFailure> } //RichError<DisruptionFailure> }
>(
  "flights-rebook/performPriceQuote",
  async ({ contractId, fareId, tripId }, thunkAPI) => {
    const schedule = makeAxiosRequest(
      api.apiV0DisruptionExerciseRebookQuoteSchedulePost({
        contractId,
        fareId,
        tripId,
        // TODO: Update API to a version where these are optional
        emailAddress: "a@b.com",
        phoneNumber: "1234567890",
      }),
      {
        discriminator: "DisruptionRebookPQResponse",
        success: DisruptionRebookPQResponseEnum.RebookPQSuccess,
        failure: DisruptionRebookPQResponseEnum.RebookPQFailure,
      },
      { failure: (error) => error.reason }
    );

    const result = await schedule.andThen((sched) =>
      polling
        .poll(
          () =>
            api.apiV0DisruptionExerciseRebookQuotePollPost({
              contractId: contractId,
              token: sched.token,
            }),
          {
            discriminator: "DisruptionRebookPollPQResponse",
            success: DisruptionRebookPollPQResponseEnum.RebookPollPQSuccess,
            failure: DisruptionRebookPollPQResponseEnum.RebookPollPQFailure,
            pending: DisruptionRebookPollPQResponseEnum.RebookPollPQPending,
          },
          { failure: (error) => error.reason }
        )
        .map((response) => ({
          token: sched.token,
          contractId,
          response,
        }))
    );

    if (result.isErr()) {
      return thunkAPI.rejectWithValue(result.error);
    }
    return result.value;
  }
);
